import { DotLottie } from '@lottiefiles/dotlottie-web';
import lottie from 'lottie-web';

/**
 * Auto-discover and initialize Lottie animations.
 *
 * For .lottie (binary dotLottie) files use a <canvas>; DotLottie renders there.
 * For .json (classic Lottie) files use a <div>; lottie-web renders SVG into it.
 *
 * Usage:
 *   <div data-lottie-src="/path/to/animation.json"
 *        data-lottie-loop="true" data-lottie-autoplay="true"></div>
 */
export function initLottieAnimations() {
  document.querySelectorAll('[data-lottie-src]').forEach((el) => {
    const srcUrl = el.dataset.lottieSrc;
    const loop = el.dataset.lottieLoop !== 'false';
    const autoplay = el.dataset.lottieAutoplay !== 'false';

    if (srcUrl.endsWith('.json')) {
      lottie.loadAnimation({
        container: el,
        renderer: 'svg',
        loop,
        autoplay,
        path: srcUrl,
      });
    } else {
      new DotLottie({ canvas: el, src: srcUrl, loop, autoplay });
    }
  });
}
